/**
 * SideNav — lateral navigation, items driven by role.
 * Desktop-first (≥1280px fixed sidebar).
 * French labels.
 */

import { NavLink } from 'react-router-dom';
import {
  ClipboardList,
  Calendar,
  UserCheck,
  Users,
  LogOut,
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const TUTOR_NAV = [
  {
    label: 'Notes',
    to: '/app/tuteur/notes',
    icon: ClipboardList,
  },
  {
    label: 'Calendrier',
    to: '/app/tuteur/calendrier',
    icon: Calendar,
  },
];

const ADMIN_NAV = [
  {
    label: 'Vérifications',
    to: '/app/admin/verifications',
    icon: UserCheck,
  },
  {
    label: 'Répétiteurs',
    to: '/app/admin/repetiteurs',
    icon: Users,
  },
];

const navByRole = {
  tutor: TUTOR_NAV,
  admin: ADMIN_NAV,
};

const SideNav = ({ role }) => {
  const { logout, user } = useAuth();
  const items = navByRole[role] ?? [];

  const handleLogout = async () => {
    try {
      await logout();
    } catch (_) {
      // ignore
    }
  };

  return (
    <aside
      className="w-64 min-h-screen bg-[#17386E] flex flex-col"
      aria-label="Navigation principale"
    >
      {/* Logo / brand */}
      <div className="px-6 py-6 border-b border-white/10">
        <span className="font-playfair font-bold text-white text-xl tracking-tight">
          MyEduCycle
        </span>
        {user && (
          <p className="text-xs text-white/60 mt-1 font-montserrat truncate">
            {user.full_name || user.first_name}
          </p>
        )}
      </div>

      {/* Nav items */}
      <nav className="flex-1 px-3 py-4 flex flex-col gap-1">
        {items.map(({ label, to, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              [
                'flex items-center gap-3 px-3 py-2.5 rounded-xl font-montserrat text-sm transition-all',
                isActive
                  ? 'bg-white/20 text-white font-semibold'
                  : 'text-white/70 hover:bg-white/10 hover:text-white',
              ].join(' ')
            }
          >
            <Icon size={18} aria-hidden="true" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="px-3 py-4 border-t border-white/10">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl font-montserrat text-sm text-white/70 hover:bg-white/10 hover:text-white transition-all"
        >
          <LogOut size={18} aria-hidden="true" />
          Déconnexion
        </button>
      </div>
    </aside>
  );
};

export default SideNav;
